import React from 'react'
export const locale = {
    curren_user_name:'Shooq Website',
    my_products:'Products & Offers',
    manage_products_offers:'Manage Products & Offers',
    add_new_product:'Add Products',
    orders:'Orders',
    manage_orders:'Manage Orders',
    what_to_sell : "What do you want to sell?",
    search_placeholder: "Search by product name or serial number",
    tooltip_search_hint: "Start by adding your products by searching for them using their name or model number",
    search:'Search',
    categories:'Categories',
    product_bulk_upload_heading: 'Do you have a ready product list?',
    product_bulk_upload_desc:'If your product list is ready and meets the listing standards, click the upload button.',
    product_bulk_upload_desc_2:'If your product list is ready, please send it to us via email:',
    product_bulk_upload_button:'Upload Product List',
    load_more_categories:'Load more categories...',
    sell_this_product:'Sell this product',
    required:':field is required',
    quantity:'Quantity',
    price:"Price",
    sku:"Product SKU",
    seller_notes:"Seller Notes",
    handling_time:"Handling Time",
    product_condition:"Product Condition",
    pcondition:"Product Condition",
    specify_your_own: 'Other?',
    choose: 'Choose...',
    product_title_ar: 'Product Title (Arabic)',
    product_description_ar: 'Product Description (Arabic)',
    product_breadcrumb_prefix: 'Product Category:',
    product_tooltip_title: 'Product Title (Arabic)',
    product_tooltip_description_ar: '<div>Product description in Arabic</div><div class="tooltip__content">What are the specifications and details of the product you want to sell?</div>',
    btn_create_product: 'Add Product',
    create_product:'Add New Product',
    btn_cancel: 'Cancel',
    btn_next: 'Next',
    btn_prev: 'Previous',
    sell_the_product: 'Sell Product: ',
    sell_product_tooltip_quantity: 'Quantity',
    sell_product_tooltip_price: 'Price',
    sell_product_tooltip_old_price: '<div>Old Price</div><div class="tooltip__content">Leave empty if the product has no old price</div>',
    sell_product_tooltip_sku: 'Product SKU',
    sell_product_tooltip_notes: '<div>Seller Notes</div><div class="tooltip__content">Add your personal notes about this product, not the product details</div>',
    sell_product_tooltip_handling_time: 'Required time to prepare the product',
    sell_product_product_condition: 'Product usage condition',
    sell_product_tooltip_free_shipping: 'Free Shipping?',
    btn_add_product_to_sell: 'Add Product',
    shipping_delivery_option: 'Order delivery method',
    shipping_to_westbank: 'Shipping to West Bank',
    shipping_to_jerusalem: 'Shipping to Jerusalem',
    shipping_to_48_area: 'Shipping to 48 Areas',
    shipping_to_gaza: 'Shipping to Gaza',
    free_shipping: 'As a seller, I will cover the shipping cost to the West Bank (you will pay the shipping fee)',
    free_shipping_jerusalem: 'As a seller, I will cover the shipping cost to Jerusalem (you will pay the shipping fee)',
    free_shipping_gaza: 'As a seller, I will cover the shipping cost to Gaza (you will pay the shipping fee)',
    free_shipping_48: 'As a seller, I will cover the shipping cost to 48 Areas (you will pay the shipping fee)',
    apply_price_to_all:'Apply price to all',
    apply_sku_to_all:'Apply SKU to all',
    copyrights:'All rights reserved - Shooq Store ©',
    numeric_only:'This field must be numeric',
    product_name: 'Product Name',
    status: 'Status',
    old_price: 'Old Price',
    updated_at: 'Last Updated',
    next:'Next',
    previous:'Previous',
    pickup_from:'The address of the store where the item is located',
    edit_product_breadcrumb_prefix:'Edit Product:',
    product_arabic_title_is_required:'Product name is required!',
    product_arabic_description_is_required:'Product description is required!',
    error_page_not_found: 'Sorry, this page does not exist or you don’t have permission to view it!',
    btn_update: 'Update',
    no_more_products_or_offers: 'Sorry, there are no more products or offers.',
    product_details: 'Product Information',
    show_product_details: 'View All Details',
    what_type_of_product: 'What type of product?',
    current_page: 'Page:',
    order_number: 'Order #',
    fees: 'Fees',
    order_sub_total: 'Subtotal',
    order_total: 'Total',
    buyer_name: 'Buyer Name',
    order_date: 'Order Date',
    no_orders_found: 'No orders were found in this list!',
    no_products_found: 'No products found in this category!',
    no_products_found_by_search: 'No search results found!',
    all_categories: 'All Categories',
    sell_product_added_successfully: 'Product successfully added to your selling list!',
    your_product_updated_successfully: 'Product updated successfully!',
    changing_order_status: 'Changing order status...',
    order_changed_successfully_to_next_step: 'Order status successfully moved to the next stage',
    an_error_occurred_while_changing_order_status: 'An error occurred while changing order status!',
    this_order_in_queue: 'This order is currently being processed...',
    did_not_you_found_your_product: 'Didn’t find your product in the results?',
    add_new_product_now: 'Add your product now',
    add_new_product_now_if_not_exists: 'Add your product to the catalog now',
    please_fill_the_required_fields: 'Please fill in the required fields!',
    an_error_occurred_while_creating_your_product: 'An unexpected error occurred while adding your product!',
    an_error_occurred_while_submitting_form: 'An unexpected error occurred while submitting the data!',
    an_error_occurred_while_check_login: 'An error occurred while checking login status',
    remove: 'Delete',
    product_images: 'Product Images',
    are_you_sure_to_delete_this_item: 'Are you sure you want to delete this item?',
    cannot_upload_this_file: 'This file cannot be uploaded!',
    you_have_canceled_the_file_upload: 'You canceled the file upload!',
    update_sell_product: 'Edit',
    update_product_props: 'Specifications',
    product_template_updated_successfully: 'Product attributes updated successfully. They will be applied after admin review.',
    you_did_not_change_values_to_update_product: 'You didn’t modify the product to update it!',
    you_did_not_change_values_to_create_product: 'You haven’t entered any product data yet!',
    login: 'Login',
    login_to_your_account: 'Login to your account',
    email: 'Email',
    password: 'Password',
    remember_me: 'Remember Me',
    logout: 'Logout',
    logout_success:'Logged out successfully.',
    please_login_to_access: 'You do not have sufficient permission to access this page. Please log in to continue.',
    failed_validation_notificant_title: (errorsCount)=>{
        switch (errorsCount){
            case 1:
                return '1 required field found!';
            case 2:
                return '2 required fields found!';
            default:
                return errorsCount+' required fields found!';
        }
    },

    get:function(name, placeholders = {}) {
        let occurrence = this[name] ||  name;
        Object.keys(placeholders).forEach(function (key) {
            occurrence = occurrence.replace(new RegExp(':' + key), placeholders[key]);
        });
        return occurrence;
    },

    login_failed:'Incorrect email or password',
    email_is_required:'Email is required.',
    password_is_required:'Password is required.',
    facebook_login_failed:'An error occurred while logging in through Facebook. Please make sure you are logged in to Facebook.',
    email_is_not_valid:'Invalid email address.',
    product_images_required:'The product requires at least one image.',
    barcode:'Barcode',
    cannot_edit_pending_product :'<div> <strong>Product pending approval:</strong> You can edit the product after approval or after requested modifications.</div>',

    mobile_confirm_title:'Mobile Number Verification',
    mobile_confirm_required_to_sell:'To sell products on Shooq.com, you must verify your account using your mobile number.',
    activation_code : 'Activation Code',
    activate:'Activate',
    send_activation : 'Send Activation Code',

    mobile_update_title:'Add Mobile Number',
    mobile_update_required:'Mobile number is required to add products.',
    mobile_number:'Mobile Number',
    save:'Save',

    mobile_is_required:"Mobile number is required",
    mobile_is_invalid:"Invalid mobile number",
    mobile_require_activation:"Mobile number requires activation",
    yes:"Yes",
    no:"No",
    add_option:"Add:",
    minimum_characters_to_search: "Minimum search length is 3 characters!",
    at_least_one_variant_required:'At least one product must be activated',
    apply_to_all:'Apply to all',
    apply_images:'Copy images to...',
    apply_all:'Apply to all',
    shipping:'Shipping',
    relogin_to_your_account:'Login',
    relogin_to_your_account_hint:'For your security, you were logged out automatically. Please log in again.',
    relogin_success:'You are logged in again. You can now save your changes.',
    buyer_notes:'Buyer Notes',
    you_have_a_note_from_buyer:'You have a note from the buyer',
    your_account_requires_email_activation:'Account requires email activation',
    resend:'Resend activation link',
    shippping_policy: 'Shipping Policy',
    email_or_mobile : 'Email or Mobile Number',
    convert_product_to_package_by_price:"Product price is less than 100 NIS.",
    convert_product_to_package_by_price_desc:"The price per piece is lower than the preferred price on Shooq. The product must contain more than one piece to reach the preferred price.",
    number_of_pieces:"Number of Pieces",
    pieces_price_is_little:"The piece price must be more than 100 NIS.",
    ok:"OK",
    cancel:"Cancel",
    price_per_piece:"Price per Piece",
    system_currency:"NIS",
    no_keep_price_as_is:"Yes, keep price as is",
    product_bulk_uploading_now:"Uploading products...",
    business_requirements_update:"Some business information is required",
    update:"Update",
    business_requirements_update_desc:"To start selling on the website, you must fill out the following fields.",
    business_contact_phone : "Business Contact Number",
    hide:'Hide',
    select_upload_category:"Select Product Category",
    mapping_upload_fields:"Map Columns",
    bulk_upload_invalid_extension:"Uploaded file extension is not allowed.",
    shipper:"Shipper",
    shipping_by_seller:"Shipping by seller (purchase orders won’t be sent to delivery company)",
    shipping_method:"Shipping Method",
    order_shipping_by_seller:"Shipped by Seller",
    order_shipping_by_shooq:"Shipped by Shooq",
    order_details:"Details",
    address:"Address",
    mobile:"Mobile",
    total_products:"Total Products",
    total_ready_orders:":completed of :total_orders",
    show_orders_count:":currentTotal of :total_orders products",
    payment_method:"Payment Method",
    shippping_policy_for_all:"Shipping Policy for All",
    email_confirm_title:'Email Requires Activation',
    email_confirm_required_to_sell:'Please activate your account via email :email to use Shooq services.',
    done:'Done',
    resend_email_activation:'Resend Activation Email',
    string_max_length_exceeded:'Text length must not exceed :size',
    views:"Views",

    update_pieces:"Update Price & Pieces",

    no_lists_uploaded:"No product lists have been uploaded yet.",
    file_name:"File Name",
    upload_date:"Upload Date",
    file_type:"File Type",
    completed_products:"Completed Products",

    pending_products:"Pending Products",

    product_title:"Product Name",
    product_description:"Product Description",
    product_image:"Product Image",
    product_title_required:"Product name field is required",
    product_price_required:"Product price field is required",
    product_quantity_required:"Product quantity field is required",

    required_field:"This field is required.",
    suggested_products:"Suggested Products",

    products_list:"Product List",
    complete:"Complete",
    select:"Select",
    deselect:"Deselect",
    sell:"Sell",
    sold:"Sold",
    selling:"Selling",
    add_product:"Add Product",

    download_bulk_samples:"Download Sample Templates",
    payment_method_fees:"Payment Method Fees",
    shipping_fees:"Shipping Fees",
    sub_total:"Subtotal",
    total:"Total",

    financial: 'Financial',
    financial_account_summary: 'Financial Account Summary',
    financial_month_summary: 'Monthly Sales Summary',
    financial_transactions: 'Financial Transactions',
    manage_bank: 'Bank Account',

    select_month: 'Select Month',
    submit: 'Submit',
    details: 'Details',
    financial_total_balance: 'Total Balance',
    financial_month_balance: 'Balance for: <span dir="rtl">:month</span>',
    sold_products: 'Sold Products',
    withdraw_request: 'Request Payout',
    you_withdrawal_requests_is_processing: 'Processing',

    my_bank_details: 'My Bank Details',
    beneficiary_name: 'Account Holder Name',
    bank_name: 'Bank Name',
    bank_account_number: 'Bank Account Number',
    bank_branch: 'Bank Branch',
    bank_iban: 'IBAN',
    save_details: 'Save Details',
    iban_is_invalid: 'Invalid IBAN!',
    please_select_valid_bank: 'Please select a bank from the list!',
    please_fill_all_required_fields: 'Please fill in all required fields',

    an_error_occurred_while_initializing_data: 'An error occurred while retrieving your information!',
    your_bank_details_saved_successfully: 'Your bank details were saved successfully',
    an_error_occurred_while_saving_your_bank_details: 'An error occurred while saving your bank details!',

    what_is_iban: 'What is IBAN?',
    what_is_iban_description: '' +
        '<p>The IBAN consists of letters and numbers and can be up to 34 characters: first two letters are the country code, followed by two check digits, followed by the domestic bank account number.</p>' +
        '<p>IBAN must not contain spaces when sent electronically. When printed, IBAN is split into groups of four characters separated by spaces. The last group can be shorter, e.g.:</p>' +
        '<p>Country ILXX XXX XXXX XXXX XXXX XXXX XXXX X</p>' +
        '<p>IBAN can only contain digits 0–9 and uppercase A–Z letters. This applies to country names too, e.g. "Saudi Arabia".</p>' +
        '',

    business_name: 'Business Name',
    payment_way: 'Payment Type',
    credit: 'Credit',
    debit: 'Debit',
    notes: 'Notes',

    month: 'Month',
    total_sales: 'Total Sales',
    total_sales_shipped_by_seller: 'Sales collected by seller',
    setup_fees: 'Setup Fees',
    lazmak_commission: 'Sales Commission',
    net_sales: 'Net Sales',
    balance: 'Balance',
    no_transactions_found: 'No financial transactions yet.',
    is_replaced_item: 'Replaced',
    please_fill_your_bank_details_to_access_to_financial_area: 'Please fill in your bank details to access financial information',
    click_here_to_go_to_manage_banks: 'Click here to fill in your bank details.',
    free_shipping_notification_message: 'By choosing one of the following options, you agree to cover the product shipping cost instead of the buyer.',

    invoices: 'Invoices',
    create_invoice: 'Create Invoice',
    receiver_name: 'Receiver Name',
    description: 'Description',
    new_invoice_row: 'Add New Row',
    invoice_row_is_required: 'Invoice items are required',
    currency: 'Currency',
    currency_ils: 'NIS',
    currency_usd: 'USD',
    is_not_valid:':field is invalid',
    view_invoice:'View Invoice',
    invoice_created_successfully:'Invoice created successfully.',
    no_invoices_found:'No invoices found from your account',
    your_store_account_has_not_been_approved_yet:'The account of store (:store_name) is currently under review by the site administration and has not been approved yet.',
};
